<template>
  <dx-popup
    :visible.sync="isVisible"
    :drag-enabled="false"
    :close-on-outside-click="true"
    :show-title="true"
    :title="$t('directory')"
    :height="800"
  >
    <dx-scroll-view>
      <dx-data-grid
        ref="refbookGrid"
        :remote-operations="remoteOperations"
        :data-source="refbookInfoStore"
        :allow-column-resizing="true"
        :allow-column-reordering="true"
        class="mb-3"
        @selectionChanged="updateSelection"
      >
        <dx-column-chooser :enabled="true" />


        <dx-column
          v-for="it in columnsFields"
          :key="it.key"
          :data-field="it.key"
          :caption="it.label"
          :max-length="it.maxLength"
          :allow-search="true"
          :width="it.width"
        ></dx-column>



        <dx-selection mode="single"/>

        <dx-editing
          :allow-updating="false"
          :allow-adding="false"
          :allow-deleting="false"
          :use-icons="true"
          mode="form"
        />

        <dx-paging :page-size="8"/>

        <dx-pager
          :show-page-size-selector="false"
          :allowed-page-sizes="[8]"
        />

<!--        <dx-state-storing-->
<!--          :enabled="true"-->
<!--          type="localStorage"-->
<!--          :storage-key="`u${user.id}-${mode}-station-selector`"-->
<!--        />-->

        <dx-search-panel
          :visible="true"
          :highlight-case-sensitive="false"
        />
      </dx-data-grid>

      <b-row class="ml-0 mr-1">
        <dx-button
          :text="$t('select')"
          :disabled="!selectedRow"
          type="success"
          styling-mode="contained"
          class="custom-btn mr-2 ml-auto"
          @click="updateInfo"
        />
        <dx-button
          :text="$t('Cancel')"
          type="success"
          styling-mode="text"
          class="custom-btn"
          @click="isVisible = false"
        />
      </b-row>
    </dx-scroll-view>
  </dx-popup>
</template>

<script>
import { mapState } from 'vuex';

import { DxButton } from 'devextreme-vue';
import { DxPopup } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';

import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxSelection,
  DxLookup,
  DxPaging,
  DxPager,
  DxStateStoring,
  DxSearchPanel,
  DxColumnChooser,
} from 'devextreme-vue/data-grid';

import createCustomStore from '@/utils/create-custom-store';

export default {
  name: 'StationsInfoModal',
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxSelection,
    DxPaging,
    DxPager,
    DxButton,
    DxPopup,
    DxScrollView,
    DxLookup,
    DxStateStoring,
    DxSearchPanel,
    DxColumnChooser,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    refbookInfoStore: createCustomStore('refbooks/api/station/'),
    selectedRow: null,
    remoteOperations: {
      sorting: true,
      filtering: true,
      paging: true,
    },
  }),
  computed: {
    ...mapState(['user']),
    isVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    columnsFields() {
      return [
        {
          key: 'code',
          label: this.$t('Station code'),
          width: 200,
        },
        {
          key: 'name',
          label: this.$t('Station name'),
        },
      ];
    },
    refbookInfo() {
      if (!this.selectedRow) {
        return null;
      }

      // return this.columnsFields.reduce((acc, it) => {
      //   if (it.key === 'code') {
      //     acc[this.mode] = this.selectedRow[it.key];
      //     return acc;
      //   }
      //
      //   acc[`${this.mode}_${it.key}`] = this.selectedRow[it.key];
      //   return acc;
      // }, {});
    },
  },
  methods: {
    updateInfo() {
      if (!this.selectedRow) {
        return;
      }

      this.$emit('update', `${this.selectedRow.code} ${this.selectedRow.name}`);
      this.isVisible = false;
    },
    updateSelection({ selectedRowsData }) {
      this.selectedRow = selectedRowsData[0];
    },
    allowEditing(e) {
      return false;
    },
  },
};
</script>

<style>
</style>
